import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Translatable } from '../translatable';
import { Translation } from '../translation-input/translation-input.component';
import { TranslationDialogData } from '../translator.component';

@Component({
  selector: 'atm-translation-dialog',
  templateUrl: './translation-dialog.component.html',
  styleUrls: ['./translation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslationDialogComponent {
  form = new FormArray<any>([]);

  get value(): Translatable {
    return (this.form.value as Translatable[])
      .filter((value) => !!value)
      .filter(({ lang, country, value }) => lang && country && value)
      .reduce(
        (acc, { lang, country, value }) => ({
          ...acc,
          [`${lang}-${country}`]: value,
        }),
        {}
      );
  }

  constructor(
    private dialogRef: MatDialogRef<TranslationDialogComponent, Translatable>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: TranslationDialogData
  ) {
    if (data.value) {
      Object.entries(data.value).forEach(([code, value]) => {
        const [lang, country] = code.split('-');
        this.add({ lang, country, value });
      });
    }
  }

  add(value?: Translation): void {
    const control = this.createControl(value);
    this.form.push(control);
  }

  onSubmit(): void {
    this.dialogRef.close(this.value);
  }

  private createControl(value?: Translation): FormControl {
    return this.fb.control(value, Validators.required);
  }
}
